import { render, staticRenderFns } from "./AwarenessDayComp.vue?vue&type=template&id=717f5259&scoped=true"
import script from "./AwarenessDayComp.vue?vue&type=script&lang=js"
export * from "./AwarenessDayComp.vue?vue&type=script&lang=js"
import style0 from "./AwarenessDayComp.vue?vue&type=style&index=0&id=717f5259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f5259",
  null
  
)

/* custom blocks */
import block0 from "./AwarenessDayComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports